import FormattedMessage from 'I18n/components/FormattedMessage';
import { Header } from 'foundations-components/transitional/components/Header';
import { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { ACTIONS, SCREENS } from '../../../../constants/Tracking';
import { AppContext, appActions } from '../../../../contexts/app/context';
import { PageLayoutPropsContext } from '../../../../contexts/pageLayout/PropsContext';
import { prettifyAppName } from '../../../../utils/general';
import HeaderTitle from '../HeaderTitle/HeaderTitle';
import NavBar from '../NavBar/NavBar';
import Tabs from '../Tabs';
import { HeaderContainer } from './Header.style';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HeaderComponent({
  currentTabHeigth
}) {
  const {
    recurringMeetings,
    usageTracker,
    resetStateBetweenCallObjects,
    meetingTopic,
    firstName,
    lastName,
    routes,
    tabsConfig,
    portalId,
    showHeader,
    showInCallTitle,
    showPlannerBackButton
  } = useContext(PageLayoutPropsContext);
  const {
    isInMeeting,
    appName,
    isPastMeeting
  } = useContext(AppContext);
  const [activeTab, setActiveTab] = useState(0);
  const {
    pathname
  } = useLocation();
  const history = useHistory();
  const {
    url
  } = useRouteMatch();
  const getTabUrl = tab => `${url === '/' ? '' : url}/${tab}`;
  const backToMeetingsPlanner = () => {
    const screenName = history.location.pathname.split('/').pop();
    resetStateBetweenCallObjects();
    history.push(`/${portalId}${routes.outsideMeeting}`);
    appActions.setIsPastMeeting(false);
    usageTracker.trackInteraction(Object.assign({
      screen: SCREENS[screenName === 'contacts' ? 'participants' : screenName]
    }, ACTIONS.planner.clickBackToPlannerButton));
  };
  useEffect(() => {
    setActiveTab(tabsConfig.findIndex(tab => pathname.endsWith(tab.id)));
  }, [pathname, tabsConfig]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavBar, {
      showBackButton: (pathname.includes(`${routes.outsideMeeting}${routes.draft}`) || showPlannerBackButton) && isInMeeting === false,
      back: backToMeetingsPlanner
    }), showHeader ? /*#__PURE__*/_jsx(HeaderContainer, {
      isRecurringMeetingExists: !!recurringMeetings.length,
      isPastMeeting: isPastMeeting,
      children: /*#__PURE__*/_jsx(Header, {
        marginBlockEnd: "0",
        paddingInlineEnd: "0",
        paddingInlineStart: "0",
        id: "ui-header",
        tabs: showInCallTitle ? /*#__PURE__*/_jsx(Tabs, {
          getTabUrl: getTabUrl,
          activeTab: activeTab,
          currentTabHeigth: currentTabHeigth
        }) : null,
        title: showInCallTitle ? /*#__PURE__*/_jsx(HeaderTitle, {
          title: meetingTopic
        }) : /*#__PURE__*/_jsx(View, {
          paddingInline: "400",
          as: "div",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.header.outsideTitle",
            options: {
              firstName,
              lastName,
              integrationName: prettifyAppName(appName)
            }
          })
        })
      })
    }) : null]
  });
}